import { connect } from 'react-redux';
import { selectFreeText, selectIsRTLLocale } from '../../selectors/appState';
import { IStoreState } from '../../types/StoreState';
import { selectMobileType } from '../../selectors/deviceType';
import { selectCardsListEmpty, selectFetchCardStatusFailed } from '../../selectors/creditCard';
import { Page } from './view';

const mapStateToProps = (store: IStoreState) => ({
  mobile: selectMobileType(store),
  isFetchCardsFailed: selectFetchCardStatusFailed(store),
  noCards: selectCardsListEmpty(store),
  rtl: selectIsRTLLocale(store),
  freeText: selectFreeText(store),
});

export const PageConnect = connect(mapStateToProps)(Page);
